import { Secrets } from 'components/secrets';

export const SecretsPage = () => {
  return <Secrets />;
};

export default SecretsPage;
